import { useEffect, ReactNode } from 'react'
import { useLocation } from 'react-router-dom'
import { trackPageView } from '@/lib/posthog'

interface PostHogProviderProps {
  children: ReactNode
}

export function PostHogProvider({ children }: PostHogProviderProps) {
  const location = useLocation()

  useEffect(() => {
    // Track page views on route changes
    trackPageView(location.pathname + location.search)
  }, [location])

  return <>{children}</>
} 